import React, { useState } from "react";
import { api, extractError } from "@/lib/api";
import { Link } from "react-router-dom";
import { fmtDay } from "@/components/timemachine/DailyReports";
import { formatHM } from "@/lib/hours";

const SOURCES = { gestionale: "Gestionale", google_calendar: "Google Calendar", gmail: "Gmail", notion: "Notion" };

function MailBody({ id, i }) {
    const [st, setSt] = useState(null);
    const toggle = async () => {
        if (st) { setSt(null); return; }
        setSt({ loading: true });
        try { setSt({ body: (await api.get(`/integrations/gmail/message/${id}`)).data.body }); }
        catch (e) { setSt({ error: extractError(e) }); }
    };
    return (
        <>
            <button onClick={toggle} data-testid={`tm-mail-read-${i}`} className="text-xs text-neutral-500 hover:text-neutral-900 underline">{st ? "Chiudi" : "Leggi"}</button>
            {st && <div className="mt-2 text-xs text-neutral-700 whitespace-pre-wrap bg-neutral-50 border border-neutral-100 rounded p-3 max-h-80 overflow-auto" data-testid={`tm-mail-body-${i}`}>
                {st.loading ? "Caricamento…" : st.error ? <span className="text-red-600">{st.error}</span> : st.body || "(email senza testo)"}
            </div>}
        </>
    );
}
const fmtTime = (iso) => (iso && iso.length > 10 && !iso.endsWith("T00:00:00") ? new Date(iso).toLocaleTimeString("it-IT", { hour: "2-digit", minute: "2-digit", timeZone: "Europe/Rome" }) : "");

function EventRow({ e, i }) {
    const est = e.estimated_hours;
    return (
        <li className="flex gap-3 py-2 text-sm" data-testid={`tm-event-${i}`}>
            <span className="w-12 shrink-0 text-xs text-neutral-400 tabular-nums pt-0.5">{e.all_day ? "—" : fmtTime(e.at)}</span>
            <span className="w-32 shrink-0 text-[10px] uppercase tracking-wider text-neutral-500 pt-1">{e.category}</span>
            <div className="min-w-0 flex-1">
                {e.link ? <Link to={e.link} className="text-neutral-900 hover:underline">{e.label}</Link>
                    : e.external_link ? <a href={e.external_link} target="_blank" rel="noopener noreferrer" className="text-neutral-900 hover:underline">{e.label}</a>
                    : <span className="text-neutral-900">{e.label}</span>}
                {est ? <span className="ml-2 text-xs text-neutral-500">stimate {formatHM(est)}</span> : null}
                {e.detail && <div className="text-xs text-neutral-500 truncate">{e.detail}</div>}
                {e.gmail_id && <MailBody id={e.gmail_id} i={i} />}
            </div>
            {e.user && <span className="text-xs text-neutral-400 shrink-0">{e.user}</span>}
        </li>
    );
}

function DayHours({ list }) {
    const done = list.filter((e) => e.type === "task_completed");
    const tot = done.reduce((s, e) => s + (Number(e.estimated_hours) || 0), 0);
    if (!done.length) return null;
    return <div className="pt-2 text-xs text-neutral-600" data-testid="tm-day-hours">{done.length} task completate · ore stimate registrate {formatHM(tot)}</div>;
}

export function EventsList({ events }) {
    const bySource = Object.entries(events.reduce((acc, e) => { (acc[e.source] = acc[e.source] || []).push(e); return acc; }, {}));
    return (
        <div className="space-y-4" data-testid="tm-events">
            {bySource.map(([src, list]) => {
                const days = [...new Set(list.map((e) => e.day))];
                return (
                    <div key={src} className="bg-white border border-neutral-200 rounded-md" data-testid={`tm-source-${src}`}>
                        <div className="px-4 py-2.5 border-b border-neutral-100 text-sm font-semibold flex justify-between">
                            <span>{SOURCES[src] || src}</span><span className="text-xs text-neutral-400 font-normal">{list.length} eventi</span>
                        </div>
                        <div className="px-4">
                            {days.map((d) => (
                                <div key={d}>
                                    {days.length > 1 && <div className="pt-3 text-[11px] uppercase tracking-wider text-neutral-500 font-semibold capitalize">{fmtDay(d)}</div>}
                                    <DayHours list={list.filter((e) => e.day === d)} />
                                    <ul className="divide-y divide-neutral-100">
                                        {list.filter((e) => e.day === d).map((e) => <EventRow key={`${e.type}-${e.at}-${e.label}`} e={e} i={events.indexOf(e)} />)}
                                    </ul>
                                </div>
                            ))}
                        </div>
                    </div>
                );
            })}
        </div>
    );
}
